import { useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { FormField } from '../../../../components/FormField/FormField';
import { Multiselect } from '../../../../components/Multiselect/Multiselect';
import { SelectItem, UserRole } from '../../../../types';
import { IUserFileds } from './UserModal';
import { UpdateUserSkeletonLoader } from '../../../../components/SkeletonLoader/UpdateUser.SkeletonLoader';
import { useUsers } from '../../../../queries/hooks/useUsers';
import { hasRole } from '../../../../utils/roles';

export function OPManagerFields() {
  const { colors } = useTheme();
  const { isLoading: areUsersLoading, data: users } = useUsers();

  const { setFieldValue, values, touched, errors, setFieldTouched } =
    useFormikContext<IUserFileds>();
  const handleError = (field) => (touched[field] ? errors[field] : '');

  const operatingPartnersOptions = useMemo(() => {
    if (!users) return [];
    // Submitters = anyone holding the OPERATING_PARTNER role. In the multi-role model this already
    // covers OP Managers who also submit their own timesheets (they hold OPERATING_PARTNER alongside
    // OP_MANAGER), so the legacy `isOp` carve-out is no longer needed. Exclude the manager being edited.
    return users
      .filter((user) => user.email !== values.email && hasRole(user, UserRole.OPERATING_PARTNER))
      .map((user) => ({
        id: user.id,
        value: user.name,
      }));
  }, [users, values.email]);

  const labelStyle = {
    color: colors.text.caption,
  };

  return areUsersLoading ? (
    <UpdateUserSkeletonLoader />
  ) : (
    <FormField
      label={'Submitters (Optional)'}
      error={handleError('operatingPartners')}
      labelStyle={labelStyle}
    >
      <Multiselect
        listboxStyle={{ height: '195px' }}
        options={operatingPartnersOptions}
        value={values?.operatingPartners as SelectItem[]}
        onChange={(_, values) => {
          setFieldValue('operatingPartners', values);
        }}
        onBlur={() => {
          setFieldTouched('operatingPartners');
        }}
        disablePortal
        fieldPlaceholder='Select submitters'
      />
    </FormField>
  );
}
